import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "truncateDecimal",
})
export class TruncateDecimalPipe implements PipeTransform {
	transform(value: number | string, decimalPlaces: number = 3, alwaysKeepDecimals: boolean = false): string {
		if (value === undefined || value === null || isNaN(Number(value))) {
			return "0";
		}

		const numStr = Number(value).toString();
		const [integerPart, decimalPart] = numStr.split(".");

		const formattedInteger = this.formatIntegerWithSpaces(integerPart);

		if (!decimalPart) {
			return alwaysKeepDecimals ? `${formattedInteger}.${"0".repeat(decimalPlaces)}` : formattedInteger;
		}

		let truncatedDecimal = decimalPart.length > decimalPlaces ? decimalPart.substring(0, decimalPlaces) : decimalPart;

		if (alwaysKeepDecimals) {
			truncatedDecimal = truncatedDecimal.padEnd(decimalPlaces, "0");
		} else {
			truncatedDecimal = truncatedDecimal.replace(/0+$/, "");
		}

		if (truncatedDecimal === "") {
			return formattedInteger;
		}

		return `${formattedInteger}.${truncatedDecimal}`;
	}

	private formatIntegerWithSpaces(integerPart: string): string {
		return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}
}
